import Axios from "../../../utils/axios";

export const FAQList = async () => {
    return await Axios().get("/common/cms/faq");
};

export const CMSPage = async (slug) => {
    return await Axios().get(`/common/cms/pages/${slug}`);
};

export const CMSPagesList = async () => {
    return await Axios().get("/common/cms/pages");
};

export const ContactUs = async (data) => {
    return await Axios().post("/common/cms/contact-us", data);
};

export const getConsent = async (type) => {
    return await Axios().get(`/common/auth/get-consent?type=${type}`);
};

